import { axios } from '../http-common';

class Transaction {
    walletReport(data) {
        return axios.get("v1/member/transaction/wallets-report", {params:data});
    }
    statements(data) {
        return axios.get("v1/member/transaction/bank-statement-report", {params:data});
    }
    availableCurrency(){
        return axios.get("v1/member/transaction/available-currency");
    }
}

export default new Transaction();